/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Model_Fable_Plan_Feat1Inputs */

const en_model_fable_plan_feat1 = /** @type {(inputs: Model_Fable_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude Fable 5 + Opus 5 + GPT 5.6 Sol`)
};

const id_model_fable_plan_feat1 = /** @type {(inputs: Model_Fable_Plan_Feat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claude Fable 5 + Opus 5 + GPT 5.6 Sol`)
};

/**
* | output |
* | --- |
* | "Claude Fable 5 + Opus 5 + GPT 5.6 Sol" |
*
* @param {Model_Fable_Plan_Feat1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_fable_plan_feat1 = /** @type {((inputs?: Model_Fable_Plan_Feat1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Fable_Plan_Feat1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_fable_plan_feat1(inputs)
	return en_model_fable_plan_feat1(inputs)
});